var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSliderDrag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#303752"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.801 6.667H6.203V4.5a.54.54 0 0 0-.075-.275.465.465 0 0 0-.198-.184.409.409 0 0 0-.257-.032.436.436 0 0 0-.23.13l-3.303 3.5a.504.504 0 0 0-.104.164.548.548 0 0 0 .104.559l3.302 3.5.05.045a.413.413 0 0 0 .468.038.473.473 0 0 0 .178-.185.542.542 0 0 0 .065-.26l-.002-2.16H9.8l.001 2.16a.54.54 0 0 0 .075.275.465.465 0 0 0 .198.184.41.41 0 0 0 .258.032.436.436 0 0 0 .23-.13l3.299-3.5a.547.547 0 0 0 0-.723l-3.299-3.5a.436.436 0 0 0-.23-.13.409.409 0 0 0-.258.032.465.465 0 0 0-.198.185.54.54 0 0 0-.075.275v2.167Z",
    fill: "#EFEFEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderDrag);
export default __webpack_public_path__ + "static/media/sliderDrag.3b73c3036747e3d49730b17ac54a24f7.svg";
export { ForwardRef as ReactComponent };